import './Message.scss';

function Message({type = '', title = ''}) {
  return <div className={`Message ${type}`}>{title}</div>;
}
export default Message;
